<script setup lang="ts">
defineExpose({
  name: 'EditIcon',
});
</script>

<template>
  <svg
    class="EditIcon"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.65039 19V19.5H5.15039H6.40039H6.6075L6.75394 19.3536L16.0039 10.1036L16.3539 9.7536L16.0075 9.40008L14.7825 8.15008L14.429 7.78935L14.0718 8.1465L4.79684 17.4215L4.65039 17.5679V17.775V19ZM18.8509 7.94611L16.1857 5.30059L17.8722 3.63161L20.5177 6.29686L18.8509 7.94611ZM4.15039 20V17.3322L14.4004 7.08216L17.0683 9.75005L6.81828 20H4.15039Z"
      fill="#686C74"
      stroke="#686C74"
    />
  </svg>
</template>

<style lang="scss" scoped>
.EditIcon {
  width: 100%;
  height: auto;
  fill: currentcolor;
}
</style>
